export default class ColorCart {
  constructor(irodamabtn) {
    this.$ = irodamabtn;
    this.jancode = this.$.closest('.js-zaiko').dataset.shohincd;
    // 色玉ボタンに以下のdata-label,data-positionがあったら、GA側の設定がないのでページ内にonclick="_ga4...."を記述させる
    if (this.$.dataset.label){
      this.gaLabel = this.$.dataset.label;
    }
    if (this.$.dataset.position){
      this.gaPosition = this.$.dataset.position;
    }
    this.irodamaZaikoContainer = this.$.closest('.js-zaiko');
    this.container = this.$.closest('.js-colorcart');
    this.irodamas = Array.from(this.container.querySelectorAll('.js-colorcart-irodama'));
    this.selectClass = 'm-selected';
    this.colorname = this.$.querySelector('img').getAttribute('src').split('/').pop().slice(0,-4);
    this.cart = this.container.querySelector('.js-colorcart-cart');
    this.btns = this.container.querySelector('.js-colorcart-cartbtn');
    this.btnDef = this.container.querySelector('.js-colorcart-btn-default');
    this.cartbtns = Array.from(this.container.querySelectorAll('.js-colorcart-link'));
    this.domain = document.domain;
    this.apiURL = '';
    if (this.domain.indexOf('shiseido.co.jp') === -1) {
      this.apiURL = 'https://www.shiseido.co.jp';
    }
    this.bind();
  }

  bind() {
    this.$.addEventListener('click', this.irodamaClick.bind(this));
  }

  irodamaClick(){
    for(let i = 0; i < this.irodamas.length; i++){
      this.irodamas[i].classList.remove(this.selectClass);
    }
    this.$.classList.add(this.selectClass);
    this.linkSet(this.jancode);
    let zaikoTarget = '.zaikokbn' + this.irodamaZaikoContainer.dataset.zaiko;
    this.btnDef.style.display = 'none';
    this.btns.querySelector('.zaikokbn1').style.display = 'none';
    this.btns.querySelector('.zaikokbn2').style.display = 'none';
    this.btns.querySelector('.zaikokbn0').style.display = 'none';
    this.btns.querySelector('.zaikokbn9').style.display = 'none';
    this.btns.querySelector(zaikoTarget).style.display = 'block';
  }

  linkSet(jancode){
    //.js-colorcart-linkにカートリンク設置
    let itemCartParam = '&sweb_shohin_cd=' + jancode;
    let onclickFunction;
    if (this.gaLabel){
      onclickFunction = "_ga4_track_dp('W+遷移', this.href, '" + this.gaLabel + "', '" + this.gaPosition + "', '', '');"
    }
    let cartUrl = this.apiURL + '/sw/products/SWFG070220.seam?actionMethod=/products%2FSWFG070220.xhtml%3AsWFG070220Action.addCartShohin' + String(itemCartParam) + '&online_shohin_ctlg_kbn=1&keyword_flg=1';
    this.cartbtns.forEach(link => {
      link.setAttribute('href',cartUrl);
      if (this.gaLabel) {
        link.setAttribute('onclick', onclickFunction);
      }
    });
  }

}

